import {  Media, Image } from 'react-bootstrap'
import { FaRegClock, FaCheck} from 'react-icons/fa'
import Link from 'next/link'
import styles from './item.module.css'

const Modules = () => (
    [
        { title: "Module 1 - Discover the Shaklee Difference", 
          mins: "47 mins", 
          status:"Completed", 
          link: "module-1",
          img: "/images/test/mod1.jpg"
        },
        { title: "Module 2 - Natural Nutrition", 
          mins: " 53 mins", 
          status:"Inprogress", 
          link: "module-2",
          img: "/images/test/mod2.jpg"
        },
        { title: "Module 3 - Healthy Weight", 
          mins: " 53 mins", 
          status:"Inprogress", 
          link: "module-3",
          img: "/images/test/mod3.jpg"
        },
        { title: "Module 4 - Beauty", 
          mins: " 53 mins", 
          status:"Completed", 
          link: "module-4",
          img: "/images/test/mod4.jpg"
        },
        { title: "Module 5 - Sports Nutrition", 
          mins: " 53 mins", 
          status:"Inprogress", 
          link: "module-5",
          img: "/images/test/mod5.jpg"
        },
        { title: "Module 6 - Green Home", 
          mins: " 53 mins", 
          status:"Inprogress", 
          link: "module-6",
          img: "/images/test/mod6.jpg"
        },
        { title: "Module 7 - Financial Wellness", 
          mins: " 53 mins", 
          status:"Inprogress", 
          link: "module-7",
          img: "/images/test/mod7.jpg"
        }
    ].map((data, idx) => (
        <div className={`${styles.timelineBorder} d-md-flex border-left  pcustom align-items-start justify-content-between pt-5`} key={idx} id={data.link}>
          <div className="d-flex align-items-center">
            <span className={`${styles.timelineCircle} d-inline-block position-relative bg-white rounded-circle border `}></span>
            <Media className="ml-5  flex-md-row flex-column" >
              <img width={140} className="mr-5" src={data.img} alt="module" />
              <Media.Body className="h10">
                <p className="mb-2 h6"><strong>{data.title}</strong></p>
                <p className="mb-1"><FaRegClock className="mr-2 h6 mb-0"/> Module time: <strong>{data.mins}</strong></p>
                <p>{data.status === 'Completed' ? <FaCheck className="mr-2 text-green h6 mb-0"/> : <Image width={20} src="../../images/test/Picture25.png" className="img-fluid mr-2"/>}{data.status} <strong>5</strong> of 5 videos</p>
              </Media.Body>
            </Media>
          </div>
          <Link href={`/learn-and-earn/${data.link}`} passHref><a className="btn rounded-pill btn-green text-white px-5 py-2 h6 mt-md-4 ml-md-0 ml-4 btnenter"><strong>Enter</strong></a></Link>
        </div>
        
    ))
 
);

export default Modules